"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteCharacteristicValueSchema = exports.IDiscreteValueSchema = exports.SimulationDefinitionSchema = void 0;
const zod_1 = require("zod");
const DesignModels_1 = require("../DesignModels");
const AbsoluteCharacteristicValueBase_1 = require("./AbsoluteCharacteristicValueBase");
exports.SimulationDefinitionSchema = zod_1.default.object({
    id: zod_1.default.string(),
});
exports.IDiscreteValueSchema = zod_1.default.object({
    value: zod_1.default.number(),
    derivedFrom: zod_1.default
        .lazy(() => zod_1.default.union([DesignModels_1.BoundaryGlobalIdRefSchema, exports.SimulationDefinitionSchema]))
        .array()
        .optional(),
});
exports.AbsoluteCharacteristicValueSchema = AbsoluteCharacteristicValueBase_1.AbsoluteCharacteristicValueBaseSchema.extend({
    discreteValues: exports.IDiscreteValueSchema.array().optional(),
});
//# sourceMappingURL=AbsoluteCharacteristicValue.js.map